/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { financialsStatementSlideDtoSchema } from "./financialsStatementSlideDtoSchema.ts";
import { z } from "zod/v4";

export const financialsStatementsDtoSchema = z.object({
  get pnl() {
    return financialsStatementSlideDtoSchema.nullish();
  },
  get cashFlow() {
    return financialsStatementSlideDtoSchema.nullish();
  },
  get balance() {
    return financialsStatementSlideDtoSchema.nullish();
  },
});
